<template>
  <div>
    <div v-show="$store.state.operate!='添加'&&$store.state.operate!='编辑'&&$store.state.operate!='详情'&&$store.state.operate!='复制'" class="page-list">
	<com-page-title  @callbackOperate="callbackOperate" ></com-page-title>
	  <!-- 搜索栏 -->
	<el-form :inline="true"  class="demo-form-inline">
		<el-form-item label="">
				  <el-input  clearable @change="callbackIndex(1)"  @clear="callbackIndex(1)" v-model="form.title" 
		placeholder="标题"></el-input>
				</el-form-item>
			
		<el-form-item  label="">
		    <el-date-picker prefix-icon="none"
		         v-model="form.dateRange"
		         type="datetimerange" :editable="false"
				 value-format='yyyy-MM-dd HH:mm:ss'
				  start-placeholder="开始时间"
				       end-placeholder="结束时间"
		         range-separator=""
				   @change="callbackIndex(1)">
		       </el-date-picker>
		  </el-form-item>
		   <el-form-item label="">
		 <el-button @click="callbackIndex(1)" type="primary">搜索</el-button>
		  </el-form-item>
		</el-form>
		
      <el-table
        :data="pageData"
        highlight-current-row
        style="width: 100%;"
		:height="$store.state.height-328"
		ref="multipleTable"
		@select-all="selectChange"
		@select="selectChange"
		@sort-change="sortChange">
	   <template slot="empty"><el-empty description="暂时没有数据"></el-empty> </template>
	   
		      <el-table-column type="selection"></el-table-column>
		   <com-page-index></com-page-index>
		   
		   <el-table-column prop='title'  label='标题' ></el-table-column>
			 <el-table-column v-if="form.status==100" prop='price' label='价格' ></el-table-column>
					<com-page-orders></com-page-orders>
						 <com-page-isshow></com-page-isshow>
				 
					 
					  <el-table-column sortable="custom"  prop='createTime' label='创建时间' ></el-table-column>
						 						
		<!-- <el-table-column prop='mediaUrl' label='视频链接' ></el-table-column>
		 <el-table-column prop='mediaImage' label='视频图片' ></el-table-column>
		 <el-table-column prop='statusType' label='类型ID' ></el-table-column>
		 <el-table-column prop='statusGroup' label='分组ID' ></el-table-column>
		 <el-table-column prop='statusText' label='状态' ></el-table-column>
		 <com-page-orders></com-page-orders>
		 <el-table-column prop='title' label='标题' ></el-table-column>
		 <el-table-column prop='subTitle' label='副标题' ></el-table-column>
		 <el-table-column prop='urls' label='链接' ></el-table-column>
		 <el-table-column prop='tag' label='标签' ></el-table-column>
		 <el-table-column prop='code' label='代码' ></el-table-column>
		 <el-table-column prop='recommend' label='推荐' ></el-table-column>
		 <com-page-isshow></com-page-isshow>
		 <el-table-column prop='postTime' label='发布时间' ></el-table-column>
		 <el-table-column prop='startTime' label='开始时间' ></el-table-column>
		 <el-table-column prop='endTime' label='结束时间' ></el-table-column>
		 <el-table-column prop='postName' label='发布人' ></el-table-column>
		 <el-table-column prop='dict' label='字典' ></el-table-column>
		 <el-table-column prop='params' label='参数' ></el-table-column>
		 <el-table-column prop='source' label='分数' ></el-table-column>
		 <el-table-column prop='price' label='价格' ></el-table-column>
		 <el-table-column prop='brief' label='摘要' ></el-table-column>
		 <com-page-imgurl column='imgurl' title='图片' ></com-page-imgurl>
		 <com-page-imgurl column='imgurls' title='图片' ></com-page-imgurl>
		 <com-page-imgurl column='imgurlArray' title='图片' ></com-page-imgurl>
		 <el-table-column prop='fileName' label='文件名称' ></el-table-column>
		 <el-table-column prop='fileUrl' label='文件链接' ></el-table-column>
		 <el-table-column prop='content' label='内容' ></el-table-column>
		 <el-table-column prop='hits' label='点击数' ></el-table-column>
		 <el-table-column prop='hitsTrue' label='真实点击数' ></el-table-column>
		 <el-table-column prop='createTime' label='创建时间' ></el-table-column>
		 <el-table-column prop='addressx' label='地址详情' ></el-table-column>
		 <el-table-column prop='address' label='地址' ></el-table-column>
		 <el-table-column prop='province' label='省' ></el-table-column>
		 <el-table-column prop='city' label='市' ></el-table-column>
		 <el-table-column prop='area' label='区' ></el-table-column>
		 <el-table-column prop='street' label='街道' ></el-table-column>
		 <el-table-column prop='longitude' label='经纬度' ></el-table-column>
		 <el-table-column prop='latitude' label='经纬度' ></el-table-column> -->
		 <!-- 操作按钮 -->
		<com-page-operate :columnList="columnList"  :pageData="pageData" @callbackOperate="callbackOperate"></com-page-operate>
      </el-table>
	    <!-- 分页页面 -->
	  <com-page-number @callbackOperate="callbackOperate" @callbackIndex="callbackIndex" ></com-page-number>
    </div>
	<!-- 表单页面 -->
    <div v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"> 
      <edit  @callbackPage="callbackPage"   :id="id"></edit>
    </div>
	<!-- 返回按钮 -->
	<com-page-return @callbackPage="callbackPage" v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"></com-page-return>
	<!-- 导入页面 -->
	<com-page-import @callbackImport="callbackImport"  v-if="$store.state.operate=='导入'"></com-page-import>
	<!-- 导出页面 -->
	<com-page-export  v-if="$store.state.operate=='导出'"></com-page-export>
 <!-- 账号配置列 -->
	<com-page-columns  @callbackColumns="callbackColumns"  v-if="$store.state.operate=='配置列'"></com-page-columns>
 </div>
</template>
<script>
import edit from "@/components/edit/com-edit-article"; 
export default {
  components: {edit },
  data() {
    return {
	columnList:[],//权限列
		pageData:[],//页面数据
		id:'',//表单主键id
		form:{//搜索表单
			dateRange: this.$dateRangeCurrent,//时间
			status:'',
			groups:'',
			title:'',
		},
    };
  },
   watch: {
      $route(to,from){ //路由监听
	   this.form.dateRange=this.$dateRangeCurrent;
	   this.form.status=to.query.status||''; 
	   this.form.groups=to.query.groups||''; 
	   this.form.title='';
	   this.callbackIndex(1)
        }
     },
  methods: {
	  extFlagChange(e){
		  this.$axios.post(`/api/Article/PostArticleextFlag` , JSON.stringify(e.id)).then(e => {
		  this.$message.success('提交成功同步到服务器');
		  			this.callbackIndex(this.pageIndex);
		    }); 
	  },
	  extMoreChange(e){
	  		  this.$axios.post(`/api/Article/PostArticleextMore` , JSON.stringify(e.id)).then(e => {
	  		  this.$message.success('提交成功同步到服务器');
	  		  			this.callbackIndex(this.pageIndex);
	  		    }); 
	  },
	  recommendChange(e){
	  		  this.$axios.post(`/api/Article/PostArticleRecommend` , JSON.stringify(e.id)).then(e => {
	  		  	this.$message.success('提交成功同步到服务器');
	  		  			this.callbackIndex(this.pageIndex);
	  		    }); 
	  },
   callbackImport(){//导入回调
		   this.callbackIndex(1)
	  },
	   selectChange(selection,row){//选择
	  this.$store.commit("saveSelect", selection);
	  },
	  sortChange(column){//排序回调
		var list= this.$store.state.list;
		list.pageOrder=column.order == 'descending'?'desc':'asc';
		list.pageSort=column.prop;
		this.$store.commit("saveList", list);
		 this.callbackIndex(1)
	},
	  callbackOperate(e){//操作按钮事件
		  if(e.operate=='添加')
			  this.id="";
		   if(e.operate=='复制'||e.operate=='编辑'||e.operate=='详情')
			  this.id=(e.data.id||'').toString();
		if(e.operate=='删除'){
			var id=this.$store.state.select.map(item=>item.id).join(',');
			 localStorage.setItem('SELECTIDS',id)
				this.$axios.post(`/api/Article/PostArticleDeleteWhere` , '').then(e => {
					 this.$message.success('删除成功到同步服务器');
							this.callbackIndex(this.pageIndex);
				  }); 
		}
	  },
	  callbackPage(e){//表单返回事件
		  if(e.statusText=='添加'||e.statusText=='编辑'){
		    this.$store.commit("saveOperate", "");
			   this.$message.success('提交成功同步到服务器');
			this.callbackIndex(1);
		  }
	  },
    callbackIndex(i) {//获取分页数据
       var data=this.$pageParams(this.form,i)
      this.$axios.get(`/api/Article/GetArticlePage`,data).then(e => {
		 this.$store.commit("saveList", e);
			this.pageData=e.pageData;
        });
    }
  },
  mounted() {//页面加载事件
    this.form.status=this.$route.query.status||'';
     this.$store.commit("saveList", {});
   this.callbackIndex(1)  
  }
  
};
</script>
<style>
</style>

